import * as React from 'react'
import { memo } from 'react'
import { useLocation } from 'react-router-dom'

import { ContributionMaterialType, ContributionType } from '../../store/contributions/contributionsTypings'

import { getLangFromPath } from '../../i18next'
import './styles.sass'

interface Props {
    data: ContributionType | ContributionMaterialType
}

const OriginalInfo: React.FunctionComponent<Props> = ({ data }: Props) => {
    const location = useLocation()
    return getLangFromPath(location.pathname) !== data.original_lang ? (
        <div className="originalInfo">
            <div className="lang">{data.original_lang}</div>
            <div className="information">
                {data.title_original && <div className="originalTitle">{data.title_original}</div>}
                <div className="originalDescription" dangerouslySetInnerHTML={{ __html: data.description_original }} />
            </div>
        </div>
    ) : (
        <></>
    )
}

export default memo(OriginalInfo)
